/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_New_SubtitleInputs */

const en_case_new_subtitle = /** @type {(inputs: Case_New_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capture identifiers, then pick a type — the rest of the form will adapt.`)
};

const pt_br2_case_new_subtitle = /** @type {(inputs: Case_New_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preencha os identificadores, escolha um tipo — o restante do formulário se adapta.`)
};

/**
* | output |
* | --- |
* | "Capture identifiers, then pick a type — the rest of the form will adapt." |
*
* @param {Case_New_SubtitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_new_subtitle = /** @type {((inputs?: Case_New_SubtitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_New_SubtitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_new_subtitle(inputs)
	return pt_br2_case_new_subtitle(inputs)
});